import { useContext } from 'react';
import { FilterContext } from 'components/filter/filters-next/FilterContext';
import { FilterSectionContext } from 'components/filter/filters-next/FilterSectionContext';

const useFilterSectionIsShown = () => {
    const { search, searchItems } = useContext(FilterContext);
    const { resource } = useContext(FilterSectionContext);

    return search.length === 0 || searchItems.some(item => item.item.resource === resource);
};

export { useFilterSectionIsShown };
